import PropTypes from "prop-types";
import styled from "styled-components";
import { codeDisplay } from "common/utils/PTO/helpers";

const Details = styled.div`
  padding-bottom: 10px;
`;

export const LumpDetails = ({ rule }) => {
  return (
    <Details>
      <h3>{codeDisplay(rule.code)}</h3>
      <p>Yearly Allowance: {rule.lumpDepositAmount} hr</p>
      <p>Carryover Limit: {rule.carryoverLimit} hr</p>
      <p>
        Yearly Usage Limit:{" "}
        {rule.usageMax === null ? "N/A" : `${rule.usageMax} hr`}
      </p>
      <p>Type: {rule.percentPayout > 0 ? "Paid" : "Unpaid"}</p>
    </Details>
  );
};

LumpDetails.propTypes = {
  rule: PropTypes.shape({
    code: PropTypes.string,
    lumpDepositAmount: PropTypes.number,
    carryoverLimit: PropTypes.number,
    usageMax: PropTypes.number,
    percentPayout: PropTypes.number,
  }).isRequired,
};
